export default {
    top_menu: [
        {name:'Pangunahing',    id:0},
        {name:'Ipakita ang Negosyo', id:1},
        {name:'Nagluluto',  id:2},
        {name:'Pulitika',   id:3},
        {name:'Maanghang',  id:4},
        {name:'Lipunan',   id:5},
        {name:'Kalusugan',   id:6},
    ],
    read_other: 'Magbasa pa',
    read_more:  'magbasa pa',
    not_found:  'Walang nahanap',
    read_also:  'Basahin din',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Lahat ng karapatan ay nakalaan.',
    subscribe: 'Подписаться',

    thank_order: 'SALAMAT SA ORDER MO',
    specialist_contact: 'Makikipag-ugnayan sa iyo ang aming espesyalista sa lalong madaling panahon, hintayin ang aming tawag.',
    attention: 'Mga diskwento mula sa mga kasosyo:',
    hurry: 'Magmadali, ang oras ng pag-activate ng diskwento ay limitado! Nasa sa iyo na ang lahat <span id="time" class="time">30:00</span> minuto para pumili ng isa sa mga natatanging produkto na ito:',

    hour_ago1: "Isang oras ang nakalipas",
    hour_ago2: "oras ang nakalipas",
    hour_ago3: "oras ang nakalipas",
    new_publications: "Mga bagong publikasyon",
    read: "Basahin",
    today_at: "Ngayon sa",
    author_names: ['Pacita Abad','Elfren Abueg','Lisa Soberano'],
    main_news: "Pangunahing balita",
    leave_already: "Aalis na? Maghintay, na-update namin ang balita para sa iyo",
    already_shared: "nakabahagi na"

}